/**
 * Page-template collection.products is not Liquid-paginateable.
 * Slice rendered cards into pages of data-fusion-page-size.
 * Optional randomize (Make Your Customization) before paging.
 */
(function () {
  const DEFAULT_SIZE = 8;
  const CARET_SVG =
    '<span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg></span>';

  function pageSize(root) {
    const n = parseInt(root.getAttribute('data-fusion-page-size') || '', 10);
    return n > 0 ? n : DEFAULT_SIZE;
  }

  function pageFromUrl(max) {
    const n = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    const page = n > 0 ? n : 1;
    return Math.min(Math.max(1, page), max);
  }

  function shuffle(list) {
    for (let i = list.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      const tmp = list[i];
      list[i] = list[j];
      list[j] = tmp;
    }
    return list;
  }

  function init(root) {
    if (!root || root.dataset.fusionPagerReady === 'true') return;

    const grid = root.querySelector('[id^="ComboProducts-"]');
    if (!grid) return;

    let items = Array.prototype.slice.call(grid.children);
    if (!items.length) return;

    if (root.getAttribute('data-fusion-randomize') === 'true') {
      items = shuffle(items);
      items.forEach(function (el) {
        grid.appendChild(el);
      });
    }

    const size = pageSize(root);
    root.dataset.fusionPagerReady = 'true';

    if (items.length <= size) {
      items.forEach(function (el) {
        el.hidden = false;
      });
      return;
    }

    const pager = document.createElement('div');
    pager.className = 'pagination-wrapper';
    grid.after(pager);

    const max = Math.ceil(items.length / size);

    function renderPager(page) {
      let html =
        '<nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled" role="list">';

      if (page > 1) {
        html +=
          '<li><a href="?page=' +
          (page - 1) +
          '" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" data-fusion-page="' +
          (page - 1) +
          '" aria-label="Previous">' +
          CARET_SVG +
          '</a></li>';
      }

      for (let i = 1; i <= max; i += 1) {
        if (i === page) {
          html +=
            '<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page">' +
            i +
            '</a></li>';
        } else {
          html +=
            '<li><a href="?page=' +
            i +
            '" class="pagination__item link" data-fusion-page="' +
            i +
            '">' +
            i +
            '</a></li>';
        }
      }

      if (page < max) {
        html +=
          '<li><a href="?page=' +
          (page + 1) +
          '" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" data-fusion-page="' +
          (page + 1) +
          '" aria-label="Next">' +
          CARET_SVG +
          '</a></li>';
      }

      html += '</ul></nav>';
      pager.innerHTML = html;
    }

    function go(page, push) {
      page = Math.min(Math.max(1, page), max);
      const start = (page - 1) * size;
      const end = start + size;
      items.forEach(function (el, i) {
        el.hidden = i < start || i >= end;
      });
      renderPager(page);
      pager.setAttribute('data-page', String(page));

      if (push) {
        const url = new URL(window.location.href);
        if (page === 1) url.searchParams.delete('page');
        else url.searchParams.set('page', String(page));
        history.pushState({ fusionComboPage: page }, '', url);
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    pager.addEventListener('click', function (event) {
      const link = event.target.closest('[data-fusion-page]');
      if (!link) return;
      event.preventDefault();
      go(parseInt(link.getAttribute('data-fusion-page'), 10), true);
    });

    window.addEventListener('popstate', function () {
      go(pageFromUrl(max), false);
    });

    go(pageFromUrl(max), false);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-fusion-combo-products]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
